import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap"; // Removed Card, Row, Col
import { useNavigate } from "react-router-dom";
import tenantService from "../services/tenantService";
import { useStateContext } from "../contexts/ContextProvider";
import { FaEdit, FaTimes, FaTrashAlt } from "react-icons/fa";
import DeleteConfirmationModal from "../components/DeleteConfirmationModal";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../components/Loading";
import ClientForm from "./ClientForm";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import awsService from "../services/awsService";

const AclList = () => {
  const [tenant, setTenant] = useState([]);
  const [allTenant, setAllTenant] = useState([]);
  const [clientDeleteModal, setClientDeleteModal] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [clientModal, setClientModal] = useState(false);
  const [mode, setMode] = useState(null);
  const [hideshow, setHideShow] = useState(false);
  const [clientData, setClientData] = useState({});
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState(null);
  const { currentColor } = useStateContext();
  const { currentMode } = useStateContext();
  const [AWS, setAWS] = useState([]);

  useEffect(() => {
    fetchAcl();
    fetchAws();
  }, []);

  const fetchAws = async () => {
    try {
      const data = await awsService.getawss({});
      setAWS(data);
    } catch (error) {
      console.error("Error fetching AWS:", error);
    }
  };

  useEffect(() => {}, []);

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchValue(value);

    const filtered_users = allTenant.filter(
      (user) =>
        user.clientName.toLowerCase().includes(value) ||
        user.clientAddress.toLowerCase().includes(value) ||
        user.clientCode.toLowerCase().includes(value) ||
        user.clientContact.toLowerCase().includes(value) ||
        user.clientGeo.toLowerCase().includes(value) ||
        user.clientLocation.toLowerCase().includes(value) ||
        user.clientLocation.toLowerCase().includes(value) ||
        user.clientContactEmail.toLowerCase().includes(value) ||
        user.clientVertical.toLowerCase().includes(value)
    );
    setTenant(filtered_users);
  };

  const handleclose = () => {
    setHideShow(false);
    setClientModal(false);
  };
  const fetchAcl = async () => {
    try {
      const data = await tenantService.gettenants();
      setAllTenant(data);
      setTenant(data);
    } catch (error) {
      console.error("Error fetching Tenant:", error);
    }
  };

  const handleEdit = (tenant) => {
    setHideShow(true);
    setClientData(tenant);
    setMode("edit");
  };

  const handleDelete = async () => {
    try {
      if (selectedClientId) {
        setLoading(true);
        console.log(selectedClientId);
        const deleted = await tenantService.deletetenant(selectedClientId);
        if (deleted.success) {
          toast.success("Client Deleted Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        setLoading(false);
        fetchAcl();
        setClientDeleteModal(false);
        setSelectedClientId(null);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleDeleteModal = (id) => {
    setSelectedClientId(id);
    setClientDeleteModal(true);
  };
  const handleCloseModal = () => {
    setHideShow(false);
    setClientDeleteModal(false);
    setSelectedClientId(null);
  };
  const handleAddClient = () => {
    console.log("clicking");
    setClientData({});
    setMode("create");
    setHideShow(true);
  };

  return (
    <>
      {" "}
      <div className="p-2">
        {/* Search and Filter Bar */}
        <div className="flex justify-end space-x-2 ">
          <input
            type="text"
            className={`px-2 py-1 transition-colors duration-300 ${
              currentMode === "Dark"
                ? "text-white bg-[#33373E] hover:bg-[#444950]"
                : "bg-white border hover:border-gray-400"
            }`}
            placeholder="Search..."
            value={searchValue}
            onChange={handleSearchChange}
          />

          {/* <input
        type="text"
        className={`px-2 py-1  ${
          currentMode === "Dark"
            ? "text-white bg-[#33373E]"
            : "bg-white border"
        }`}
        placeholder="Filter..."
        value={searchValue}
        onChange={handleSearchChange}
      /> */}
          <TooltipComponent content="Add Client" position="BottomRight">
            {" "}
            <button
              className="flex items-center justify-center px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
              onClick={() => handleAddClient()}
              style={{ backgroundColor: currentColor }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
            </button>
          </TooltipComponent>
        </div>
      </div>
      <hr className="border-gray-500 border-1 p-0 m-0" />
      <div className=" mx-8 my-4 p-2 ">
        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {tenant.map((aclItem) => (
            <div
              key={aclItem._id}
              className={`p-3 shadow-md cursor-pointer flex flex-col ${
                currentMode === "Dark"
                  ? "text-white bg-[#33373E]"
                  : "bg-white border border-gray-300"
              }`}
              style={{
                height: "300px",
                width: "300px",
                fontFamily: '"Poppins", sans-serif',
              }}
            >
              <div className="flex justify-between items-start mb-4">
                <div className="flex items-center">
                  <span
                    style={{
                      mask: `url("/icons/clipart-client.svg") center no-repeat`,
                      WebkitMask: `url("/icons/clipart-client.svg") center no-repeat`,
                      maskSize: "contain", // Adjust the mask size here
                      WebkitMaskSize: "contain",
                      display: "block",
                      width: "60px",
                      height: "60px",
                      marginRight: "5px",
                      backgroundColor: currentColor,
                      transition: "background-color 0.3s",
                    }}
                  ></span>
                </div>
                <div className="flex space-x-2">
                  <TooltipComponent content="Edit" position="BottomCenter">
                    <button
                      className="px-2 py-2 mt-3 text-white rounded-lg transition duration-300 ease-in-out hover:bg-gray-700"
                      style={{ backgroundColor: currentColor }}
                      onClick={() => handleEdit(aclItem)}
                    >
                      {/* <FaEdit /> */}
                      <span
                        style={{
                          mask: `url(/icons/edit-icon.svg) center no-repeat`,
                          WebkitMask: `url(/icons/edit-icon.svg) center no-repeat`,
                          maskSize: "contain", // Adjust the mask size here
                          WebkitMaskSize: "contain",
                          display: "block",
                          width: "15px",
                          height: "15px",
                          backgroundColor: "white",
                          transition: "background-color 0.3s",
                        }}
                      ></span>
                    </button>
                  </TooltipComponent>
                  <TooltipComponent content="Delete" position="BottomCenter">
                    <button
                      className="px-2 py-2 mt-3 bg-red-500 text-white rounded-lg hover:bg-red-600"
                      onClick={() => handleDeleteModal(aclItem._id)}
                      style={{ backgroundColor: currentColor }}
                    >
                      <span
                        style={{
                          mask: `url(/icons/delete-icon.svg) center no-repeat`,
                          WebkitMask: `url(/icons/delete-icon.svg) center no-repeat`,
                          maskSize: "contain", // Adjust the mask size here
                          WebkitMaskSize: "contain",
                          display: "block",
                          width: "15px",
                          height: "15px",
                          backgroundColor: "white",
                          transition: "background-color 0.3s",
                        }}
                      ></span>
                      {/* <FaTrashAlt /> */}
                    </button>
                  </TooltipComponent>
                </div>
              </div>
              <div className="flex flex-1">
                <div className="flex-1 pr-2 ">
                  <div className="flex flex-col ">
                    <div className="flex justify-between ">
                      <div>
                        <h3
                          className="text-xs font-semibold "
                          style={{ color: currentColor }}
                        >
                          Client Name
                        </h3>
                        <p className="text-xs" style={{ marginBottom: "0px" }}>
                          {aclItem.clientName || <>&nbsp;</>}
                        </p>
                      </div>
                    </div>
                    <hr
                      className="my-1 mb-4"
                      style={{
                        backgroundColor: currentColor,
                        height: "2px",
                        border: "none",
                        opacity: "0.8",
                      }}
                    />

                    <div className="flex justify-between ">
                      <div>
                        <h3
                          className="text-xs
                       font-semibold"
                          style={{ color: currentColor }}
                        >
                          Email
                        </h3>
                        <p
                          className="text-xs
                    "
                          style={{ marginBottom: "0px" }}
                        >
                          {aclItem.clientContactEmail || <>&nbsp;</>}
                        </p>
                      </div>
                    </div>
                    <hr
                      className="my-1 mb-4"
                      style={{
                        backgroundColor: currentColor,
                        height: "2px",
                        border: "none",
                        opacity: "0.8",
                      }}
                    />
                    <div className="flex justify-between">
                      <div>
                        <h3
                          className="text-xs
                       font-semibold"
                          style={{ color: currentColor }}
                        >
                          Contact Number
                        </h3>
                        <p
                          className="text-xs
                    "
                          style={{ marginBottom: "0px" }}
                        >
                          {aclItem.clientContact || <>&nbsp;</>}
                        </p>
                      </div>
                    </div>
                    <hr
                      className="my-1 mb-2"
                      style={{
                        backgroundColor: currentColor,
                        height: "2px",
                        border: "none",
                        opacity: "0.8",
                      }}
                    />
                  </div>
                </div>
                <div className="flex-1 pl-2">
                  <div className="flex flex-col mb-4">
                    <div className="flex justify-between">
                      <div>
                        <h3
                          className="text-xs
                       font-semibold"
                          style={{ color: currentColor }}
                        >
                          Client GEO
                        </h3>
                        <p className="text-xs" style={{ marginBottom: "0px" }}>
                          {aclItem.clientGeo || <>&nbsp;</>}
                        </p>
                      </div>
                    </div>
                    <hr
                      className="my-1 mb-4"
                      style={{
                        backgroundColor: currentColor,
                        height: "2px",
                        border: "none",
                        opacity: "0.8",
                      }}
                    />
                    <div className="flex justify-between ">
                      <div>
                        <h3
                          className="text-xs
                       font-semibold"
                          style={{ color: currentColor }}
                        >
                          Client Vertical
                        </h3>
                        <p
                          className="text-xs
                    "
                          style={{ marginBottom: "0px" }}
                        >
                          {aclItem.clientVertical || <>&nbsp;</>}
                        </p>
                      </div>
                    </div>

                    <hr
                      className="my-1 mb-4"
                      style={{
                        backgroundColor: currentColor,
                        height: "2px",
                        border: "none",
                        opacity: "0.8",
                      }}
                    />
                    <div className="flex justify-between">
                      <div>
                        <h3
                          className="text-xs
                       font-semibold"
                          style={{ color: currentColor }}
                        >
                          AWS Account
                        </h3>
                        <p className="text-xs" style={{ marginBottom: "0px" }}>
                          {(() => {
                            const awsAccountId =
                              aclItem?.awsAccounts?.[0]?.awsId;
                            if (!awsAccountId) {
                              console.error(
                                "AWS ID is missing or undefined in aclItem."
                              );
                              return (
                                <>
                                  {" "}
                                  <b>-</b>&nbsp;
                                </>
                              );
                            }

                            const awsAccount = AWS.find(
                              (o) => o._id === awsAccountId
                            );
                            if (!awsAccount) {
                              console.error(
                                `No AWS account found for ID: ${awsAccountId}`
                              );
                              return (
                                <>
                                  {" "}
                                  <b>-</b>&nbsp;
                                </>
                              );
                            }

                            return awsAccount.accountName;
                          })()}
                        </p>
                        {/* If you want to include bucket names, uncomment and enhance the following code */}
                        {/* <p className="text-xs" style={{ marginBottom: "0px" }}>
{(() => {
  const bucketList = aclItem?.awsAccounts?.[0]?.bucketList;
  if (!bucketList || bucketList.length === 0) {
    console.error("Bucket list is empty or undefined.");
    return <>&nbsp;</>;
  }

  return bucketList.map((bucket, index) => (
    <span key={index}>
      {bucket.bucketName}
      {index < bucketList.length - 1 ? ", " : ""}
    </span>
  ));
})()}
</p> */}
                      </div>
                    </div>
                    <hr
                      className="my-1 mb-4"
                      style={{
                        backgroundColor: currentColor,
                        height: "2px",
                        border: "none",
                        opacity: "0.8",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {clientDeleteModal && (
          <DeleteConfirmationModal
            onDelete={handleDelete}
            onClose={handleCloseModal}
          />
        )}

        <Modal
          show={hideshow}
          onClose={() => setHideShow(false)}
          onHide={() => setHideShow(false)}
          size="xxl-down'"
          backdrop="static"
          keyboard={false}
          dialogClassName="modal-90w"
          className="modal-dialog-centered modal-90w "
          style={{
            maxHeight: "400px",
            overflowY: "auto",
            borderRadius: "none ",
          }}
        >
          <Modal.Header
            className={`  ${
              currentMode === "Dark"
                ? "text-white bg-[#33373E]"
                : "bg-gray-200 border-b border-gray-300  "
            }`}
            // closeButton
            style={{ borderRadius: "none" }}
          >
            <Modal.Title className="text-md font-semibold w-full">
              <div className="flex mt-0 justify-between items-center">
                <div className="flex items-center" style={{ width: "100%" }}>
                  {/* <img
  src="/icons/client-icon.svg"
  alt="icon"
  className="w-10 h-10"
  /> */}
                  <span
                    style={{
                      mask: `url(/icons/client-icon.svg) center no-repeat`,
                      WebkitMask: `url(/icons/client-icon.svg) center no-repeat`,
                      maskSize: "contain", // Adjust the mask size here
                      WebkitMaskSize: "contain",
                      display: "block",
                      width: "35px",
                      height: "35px",
                      backgroundColor: currentColor,
                      transition: "background-color 0.3s",
                      marginRight: "8px",
                    }}
                  ></span>

                  <h5 className="mt-2">
                    {mode === "create" ? "Add Client" : "Update Client"}
                  </h5>
                </div>
                <div
                  className="flex justify-end"
                  onClick={() => setHideShow(false)}
                >
                  <span
                    style={{
                      mask: `url(/icons/close.svg) center no-repeat`,
                      WebkitMask: `url(/icons/close.svg) center no-repeat`,
                      maskSize: "contain", // Adjust the mask size here
                      WebkitMaskSize: "contain",
                      display: "block",
                      width: "25px",
                      height: "25px",
                      backgroundColor: currentColor,
                      transition: "background-color 0.3s",
                      marginRight: "8px",
                      cursor: "pointer",
                    }}
                  ></span>
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className={`overflow-auto  ${
              currentMode === "Dark"
                ? "text-white bg-[#33373E]"
                : "bg-white border"
            }`}
            style={{ borderRadius: "none" }}
          >
            <ClientForm
              mode={mode}
              handleCloseModal={handleclose}
              modalshow={true}
              clientData={clientData}
              fetchClients={fetchAcl}
            />
          </Modal.Body>
        </Modal>

        {loading && (
          <Loading loading={"deleting"} currentColor={currentColor} />
        )}
        <ToastContainer />
      </div>
    </>
  );
};

export default AclList;
